import styles from './Empty.module.css'

export const Empty = () => {
  return <div className={styles.empty}>No Results</div>;
};
